// src/routes/path.js (KEEP THIS ONE)
export const ROUTES = {
  HOME: "/",
  SHOP: "shop",
  PRODUCT_DETAIL: "product/:id",
  CART: "cart",
  REVIEW_ORDER: 'review-order',
  PAYMENT: 'payment',
  MAP: "map",
  COMMUNITY: "community",
  AUTH: "auth",
  PROFILE: "profile",
  ORDERS: "orders",
  ORDER_CONFIRMATION: "order-confirmation",
  PRIVACY_POLICY: "privacy-policy",
};